<template>
  <div>
    <Surveys />
  </div>
</template>

<script>
import Surveys from '@/components/Surveys.vue'

export default {
  name: 'Results',
  components: {
    Surveys
  }
}
</script>
